import type { ConnectionState } from "../lib/styxClient";

type Props = {
  conn: ConnectionState;
  visible: boolean;
};

/** Step 12: blocks interaction while WS is not open (reconnect backoff). */
export function ConnectionOverlay({ conn, visible }: Props) {
  if (!visible) return null;

  const title = conn === "connecting" ? "Подключение к релею…" : "Связь потеряна";
  const detail =
    conn === "connecting"
      ? "Устанавливается защищённое соединение"
      : "Повторное подключение с увеличением задержки — сообщения на сервере ждут, пока вы офлайн";

  return (
    <div className="conn-overlay" role="status" aria-live="polite">
      <div className="conn-overlay__panel">
        <div className="conn-overlay__title">{title}</div>
        <div className="conn-overlay__detail">{detail}</div>
      </div>
    </div>
  );
}
